import React from "react"
import { Link } from 'gatsby'
import BlockContent from "@sanity/block-content-to-react"
import clientConfig from "../../client-config"

function ExternalLink({ mark, children }) {
  return (
    <a href={mark.url} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  )
}

const serializers = {
  types: {
    block: ({ node, children }) => {
      switch (node.style) {
	      case 'h1':
	        return <h1>{children}</h1>
        case 'h2':
	        return <h2>{children}</h2>
        case 'h3':
	        return <h3>{children}</h3>
        case 'h4':
	        return <h4>{children}</h4>
        case 'h5':
	        return <h5>{children}</h5>
        case 'h6':
	        return <h6>{children}</h6>
        case 'normal':
          return <p>{children}</p>
        case 'span':
          return <span>{children}</span>
        default:
          return <p>{children}</p>
      }
    },
  },
  marks: {
    internalLink: ({ mark, children }) => {
      const {slug = {}} = mark
      const url = `${slug.current}`
      return <Link to={url}>{children}</Link>
    },
    externalLink: ExternalLink,
  }
}

export default function PortableText({ blocks }) {
  return <BlockContent blocks={blocks} serializers={serializers} {...clientConfig} />
}